import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

type ExReleaseSearch = {
  tab?: "general" | "info" | "files"
  mode?: "edit"
}

const ExReleasePage = lazy(
  () => import("../../../../../components/WMS/ExReleases/ExReleasePage.tsx"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/ex-releases/$exRelease",
)({
  component: ExReleaseRoute,
  validateSearch: (search: Record<string, unknown>): ExReleaseSearch => {
    const next: ExReleaseSearch = {}
    if (
      search.tab === "general" ||
      search.tab === "info" ||
      search.tab === "files"
    ) {
      next.tab = search.tab
    }
    if (search.mode === "edit") {
      next.mode = "edit"
    }
    return next
  },
})

function ExReleaseRoute() {
  return (
    <LazyRoutePage>
      <ExReleasePage />
    </LazyRoutePage>
  )
}
